const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const depositRouter = new VueRouter({
    routes: [
        { 
            name: 'deposit-01',
            path: '/',
            component: require('./components/pages/deposit/01.vue').default 
        },
        {
            name: 'deposit-02',
            path: '/02',
            component: require('./components/pages/deposit/02.vue').default
        },
        {
            name: 'deposit-03',
            path: '/03',
            component: require('./components/pages/deposit/03.vue').default
        },
        {
            name: 'deposit-04',
            path: '/04',
            component: require('./components/pages/deposit/04.vue').default
        }
    ],
})

Vue.component('deposit-entry', require('./components/pages/deposit/Index.vue').default)

if ($('#deposit-app').length) { // for deposit-app
    const app = new Vue({
        router: depositRouter
    }).$mount('#deposit-app');
}